import { SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import AddIcon from '@mui/icons-material/Add';

const container: SxProps = {
  backgroundColor: 'customGrey.light',
  borderStyle: 'dotted',
  borderColor: 'customGrey.medium',
  borderWidth: 2,
  color: 'text.primary'
};

type Props = {
  onClick: () => void;
  children: React.ReactNode;
};

export const AddSectionButton: React.FC<Props> = ({ onClick, children }) => {
  return (
    <Button onClick={onClick} fullWidth startIcon={<AddIcon />} sx={container}>
      {children}
    </Button>
  );
};
